<main @fade>
  <nb-card>
    <nb-card-body [nbSpinner]="loading">
      <div [ngClass]="{'active': productShow}" *ngIf="(data | async) as list">
        <div class="dam__center-title">
          <h4>Корзина</h4>

          <app-view-changing-tabs (viewChangeEvent)="showProductBlocks($event)" [isShowList]="isShowList"/>
        </div>

        <div *ngIf="dayInBasket" class="log">
          <div>Количество дней, который элемент будет в корзине до полного удаления: {{dayInBasket}} д.</div>
          <div><a href="/cabinet/dam/basket/log">Лог полного удаления</a></div>
        </div>

        <app-plates-view [isShowProductList]="isShowList" [pagination]="pagination" [damElements]="list" (elementClickEventEmitter)="elementClickEventHandler($event)"/>
      </div>
    </nb-card-body>
  </nb-card>
</main>
